import bugsnagClient from '../components/bugsnag';
import {
  API_HARDWARE_PRODUCT_SUCCESS,
  API_PRODUCT_FIELD_SUCCESS,
  PRODUCT_LOADED,
} from '../constants';
import { fetchOptions, fetchPostOptions, baseUrl, getCredentials } from '../api/http.jsx';
import { FourOhOneErrorDispatch } from './system.js';
import CustomToast from '../components/Redesing/custom-toast';
export const apiHardwareProductSuccess = (hardwareProducts) => ({
  type: API_HARDWARE_PRODUCT_SUCCESS,
  hardwareProducts,
});

export const apiProductFieldsSuccess = (productFields) => ({
  type: API_PRODUCT_FIELD_SUCCESS,
  productFields,
});

const hardwareProductLoaded = (loaded) => ({
  type: PRODUCT_LOADED,
  loaded,
});

export const getAllHardwareProducts = () => (dispatch, getState) => {
  dispatch(hardwareProductLoaded(false));
  const state = getState();
  const fetchOps = fetchOptions(
    state.admin.admin.admin.email,
    state.admin.admin.token,
    state.system.current.id
  );
  return fetch(`${baseUrl}/hardware/product`, fetchOps)
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 200) {
        if (response.message !== undefined) {
          return dispatch(apiHardwareProductSuccess(response.message));
        }
      } else {
        dispatch(FourOhOneErrorDispatch(response));
      }
    })
    .catch((error) => {
      console.error(error);
      bugsnagClient.notify(error);
      return error;
    });
};

// for adding new products, movatic only
export const getAllProductFields = () => {
  const { adminEmail, adminToken, systemId } = getCredentials();
  const fetchOps = fetchOptions(adminEmail, adminToken, systemId);
  return fetch(`${baseUrl}/hardware/product/info`, fetchOps)
    .then((response) => response.json())

    .then((response) => {
      if (response.status === 200) {
        return response.message;
      }
      throw new Error(response?.error_description);
    })

    .catch((error) => {
      CustomToast({
        type: 'error',
        message: `Oops! Looks like there was an error while loading the product fields. Please try again later. ${error}`,
        duration: 5000,
      });
    });
};

export const addHardwareProduct = (product) => {
  const { adminEmail, adminToken, systemId } = getCredentials();
  const fetchOps = fetchPostOptions(adminEmail, adminToken, systemId, product, 'Post');

  return fetch(`${baseUrl}/hardware/product/add`, fetchOps)
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 200) {
        CustomToast({
          type: 'success',
          message: `${response.message} Remember to add a product version!`,
          duration: 5000,
        });
        return response.message;
      }
      throw new Error(response?.error_description);
    })

    .catch((error) => {
      CustomToast({
        type: 'error',
        message: `Oops! Looks like there was an error while adding the product. Please try again later. ${error}`,
        duration: 5000,
      });
    });
};

export const addHardwareProductVersion = (version) => {
  const { adminEmail, adminToken, systemId } = getCredentials();
  const fetchOps = fetchPostOptions(adminEmail, adminToken, systemId, version, 'Post');

  return fetch(`${baseUrl}/hardware/product/version`, fetchOps)
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 200) {
        return response.message;
      }
      throw new Error(response?.error_description);
    })
    .catch((error) => {
      CustomToast({
        type: 'error',
        message: `Oops! Looks like there was an error while adding the product version. Please try again later. ${error}`,
        duration: 5000,
      });
    });
};
